// Enumerations
import { AppStatesEnumeration } from 'enumerations/app-states.enumeration';

const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.genericComponents.errorProvider.';

const ONBOARDING_FLOW_TITLES = {
    [AppStatesEnumeration.CHECKOUT_SIGNING]: `${DOMAIN}contractErrorTitle`,
    [AppStatesEnumeration.CHECKOUT_IDENTIFICATION]: `${DOMAIN}kycErrorTitle`,
    [AppStatesEnumeration.CHECKOUT_DOWNPAYMENT]: `${DOMAIN}paymentErrorTitle`,
    [AppStatesEnumeration.CHECKOUT_INCOME]: `${DOMAIN}proofIncomeErrorTitle`,
    [AppStatesEnumeration.CHECKOUT_PENDING]: `${DOMAIN}uploadIdErrorTitle`,
  },
  ONBOARDING_FLOW_DESCRIPTIONS = {
    [AppStatesEnumeration.CHECKOUT_SIGNING]: `${DOMAIN}contractErrorDescription`,
    [AppStatesEnumeration.CHECKOUT_IDENTIFICATION]: `${DOMAIN}kycErrorDescription`,
    [AppStatesEnumeration.CHECKOUT_DOWNPAYMENT]: `${DOMAIN}paymentErrorDescription`,
    [AppStatesEnumeration.CHECKOUT_INCOME]: `${DOMAIN}proofIncomeErrorDescription`,
    [AppStatesEnumeration.CHECKOUT_PENDING]: `${DOMAIN}uploadIdErrorDescription`,
  },
  BUTTON_RETRY = `${DOMAIN}retryButton`,
  BUTTON_RETURN_AMAZON = `${DOMAIN}returnToAmazonButton`,
  UPLOAD_ID_CAMERA_FAILURE_ERROR = {
    DESCRIPTION: `${DOMAIN}uploadIdCameraErrorDescription`,
    TITLE: `${DOMAIN}uploadIdCameraErrorTitle`,
  },
  UPLOAD_ID_BIZUM_ERROR = {
    DESCRIPTION: `${DOMAIN}uploadIdBizumErrorDescription`,
  };

export {
  BUTTON_RETRY,
  BUTTON_RETURN_AMAZON,
  ONBOARDING_FLOW_TITLES,
  ONBOARDING_FLOW_DESCRIPTIONS,
  UPLOAD_ID_CAMERA_FAILURE_ERROR,
  UPLOAD_ID_BIZUM_ERROR,
};
